export const PRODUCTS = {
  HOME_PAGE: 'homepage',
  EVENTS_PAGE: 'events',
  EVENT_PAGE: 'event',
  COURSES_PAGE: 'courses',
  NEOVARSITY_PAGE: 'neovarsity_homepage',
  ACADEMY_PAGE: 'academy_homepage',
  DATASCIENCE_PAGE: 'data_science_homepage',
  AIML_PAGE: 'ai_ml_homepage',
  MENTEE_DASHBOARD_PAGE: 'learner_dashboard',
  TEST_PAGE: 'scaler_enrolment',
  REVIEW_PAGE: 'review_homepage',
  CRT_PAGE: 'career_roadmap_tool',
  MEETINGS_PAGE: 'meetings',
  DEVOPS_PAGE: 'devops_homepage',
};

export const PLATFORMS = {
  SCALER_ANDROID: 'scaler_android',
  DESKTOP: 'desktop',
  MOBILE: 'mobile',
  TABLET: 'tablet',
};

export const PROGRAMS = {
  SOFTWARE_DEVELOPMENT: 'software_development',
  DATA_SCIENCE: 'data_science',
  AI_ML: 'ai_ml',
};

export const INTENTS = {
  RCB: 'rcb',
  RCB_FORM: 'rcb_form',
  DOWNLOAD_CURRICULUM: 'sign_up_for_curriculum',
  BOOK_LIVE_CLASS: 'book_live_class',
  MEETING_JOINED: 'meeting_joined',
  EVENT_REGISTER: 'event_register',
  CRT: 'crt',
  AI_ML_REGISTRATION: 'ai_ml_registration',
};
